import { twMerge } from 'tailwind-merge';

const Label = ({ children, className, ...properties }) => (
    <label className={twMerge(`font-medium`, className)} {...properties}>
        {children}
    </label>
);

export default Label;
